import React from "react";
import PropTypes from "prop-types";

import Icon from "components/Icon";
import css from "./ArticleTags.module.scss";

const ArticleTags = ({ tags }) => {
    return (
        <div className={css.IEWrapper}>
            <div className={css.ArticleTags}>
                <div className={css.iconWrapper}>
                    <Icon icon="arrows" className={css.icon} />
                </div>
                {tags && <div className={css.tags}>{tags}</div>}
            </div>
        </div>
    );
};

ArticleTags.propTypes = {
    tags: PropTypes.string.isRequired
};

export default ArticleTags;



// WEBPACK FOOTER //
// ./src/components/ArticleTags/ArticleTags.jsx